export default {
  close: 'Close',
  dataIterator: {
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...',
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    pageText: '{0}-{1} of {2}',
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
  },
  datePicker: {
    itemsSelected: '{0} selected',
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual',
  },
  calendar: {
    moreEvents: '{0} more',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
  utilities: 'Utilities',
  checkTemplateProxy: {
    title: 'Check template proxy response',
    response: 'Template proxy response',
    fields: {
      method: 'Request method',
      path: 'Proxy path',
      message: 'Message param',
      subscriber: 'Subscriber param',
      address: 'Address param',
      protocol: 'Protocol param',
    },
  },
  hasMNOBans: 'Has MNO bans',
  blockInternational: 'Block international traffic',
  mainMenu: 'Main menu',
  dashboard: 'Dashboard',
  profile: 'Profile',
  changePassword: 'Change Password',
  admin: 'Admin',
  users: 'Users',
  contract: 'Contract',
  contracts: 'Contracts',
  services: 'Services',
  senders: 'Senders',
  templates: 'Templates',
  logout: 'Logout',
  collapse: 'Collapse',
  localeChange: 'Русский',
  login: 'Login',
  password: 'Password',
  forgotPassword: 'Forgot your password?',
  authorize: 'Login',
  incorrectAuth: 'Incorrect login or password',
  deleteUsersConfirmation: 'Are you sure you want to delete selected users?',
  name: 'Name',
  email: 'Email',
  fullName: 'Full Name',
  isActive: 'Is Active',
  isPermanent: 'Is Permanent',
  bannedAt: 'Banned At',
  numberOfBans: '# of Bans',
  passBadMessages: 'Pass bad messages',
  currentlyPassBadMessages: 'currently pass',
  currentlyNotPassBadMessages: 'currently not pass',
  currentlyIgnoreUserBans: 'currently ignore',
  currentlyNotIgnoreUserBans: 'currently not ignore',
  title: 'Name',
  isSuperuser: 'Is Superuser',
  userIsActive: 'User is active',
  templateIsActive: 'Template is active',
  userIsSuperuser: 'User is superuser',
  actions: 'Actions',
  manageUsers: 'Manage Users',
  createUser: 'Create User',
  add: 'Add',
  create: 'Create',
  addMNO: 'Add MNO',
  addMNOSender: 'Add MNO Sender',
  deleteMask: 'deleteMask',
  checkMNOMask: 'Check MNO mask',
  checkMask: 'Check mask',
  addMask: 'Add mask',
  addMNOMask: 'Add MNO mask',
  originalMNOName: 'Original MNO name',
  masks: 'Masks',
  MNOMasks: 'MNO Masks',
  mask: 'Mask',
  MNO: 'MNO',
  originalName: 'Original Name',
  maskOrPhone: 'Mask or Phone',
  deleteMNOMaskConfirm: 'Are you sure you want to delete this MNO mask?',
  edit: 'Edit',
  editProfile: 'Edit Profile',
  delete: 'Delete',
  welcome: 'Welcome',
  currentlyActive: 'currently active',
  currentlyNotActive: 'currently not active',
  currentlySuperuser: 'currently is a superuser',
  currentlyNotSuperuser: 'currently is not a superuser',
  setPassword: 'Set Password',
  confirmPassword: 'Confirm Password',
  cancel: 'Cancel',
  reset: 'Reset',
  save: 'Save',
  submit: 'Submit',
  editUser: 'Edit User',
  user: 'User',
  proxyHost: 'Proxy host',
  proxyReportHost: 'Reports proxy host',
  deleteServicesConfirmation: 'Are you sure you want to delete selected services?',
  manageServices: 'Manage Services',
  createService: 'Create Service',
  editService: 'Edit Service',
  deleteSendersConfirmation: 'Are you sure you want to delete selected senders?',
  deleteMNOSendersConfirmation: 'Are you sure you want to delete selected MNO senders?',
  deleteMNOConfirmation: 'Are you sure you want to delete selected MNO?',
  manageSenders: 'Manage Sender',
  createSender: 'Create Sender',
  editSender: 'Edit Sender',
  editTemplate: 'Edit Template',
  createTemplate: 'Create Template',
  proxyCallBackUrl: 'Proxy callback url',
  phone: 'Phone number',
  proxyError: 'Proxy error',
  proxyErrors: 'Proxy Errors',
  createProxyUserBan: 'Ban user',
  manageProxyErrors: 'Manage Proxy Errors',
  proxyUserBans: 'Proxy Users Bans',
  ignoreUserBans: 'Ignore User Bans',
  editProxyError: 'Edit proxy error',
  createProxyError: 'Create proxy error',
  statusCode: 'Status code',
  response: 'Response',
  errorCode: 'Error code',
  description: 'Description',
  userBanDuration: 'User ban duration',
  service: 'Service',
  template: 'Template',
  sender: 'Sender',
  checkTemplate: 'Check template',
  message: 'Message',
  parseMessage: 'Parse message',
  bans: 'Bans',
  list: 'List',
  management: 'Management',
  statistics: 'Statistics',
  manageProxyUserBans: 'Manage Proxy User Bans',
  activeCheckbox: 'Active',
  notActiveCheckbox: 'Not active',
  activate: 'Activate',
  deactivate: 'Deactivate',
  priority: 'Priority',
  editPriority: 'Edit priority',
  managePriorities: 'Manage priorities',
  priorities: 'Priorities',
  ratePerSecond: 'Rate per second',
  manageMNOs: 'Manage mnos',
  mnos: 'MNOs',
  mno: 'MNO',
  type: 'Type',
  conn: 'Connection',
  editMNO: 'Edit MNO',
  editMNOSender: 'Edit MNO Sender',
  mnoSenders: 'MNO Senders',
  tag: 'Tag',
  tags: 'Tags',
  mnoBans: 'MNO bans',
  mnoBan: 'MNO ban',
  gateway: 'Gateway',
  commentary: 'Commentary',
  banPolicies: 'Ban Policies',
  banMultiplier: 'Ban Multiplier',
  maxBans: 'Max Bans',
  permanentBanDuration: 'Permanent Ban Duration',
  repeatedBan: 'Repeated Ban',
  moUnban: 'Unban on MO',
  mtUnban: 'Unban on MT',
  updateBanPolicy: 'Update Ban Policy',
  createBanPolicy: 'Create Ban Policy',
  modules: 'Modules',
  authApi: 'User Management',
  messagesApi: 'Sending messages',
  messagesStat: 'Messages statistics',
};
